export const DEFAULT_TARGET_PER_HOUR = 6
export const DEFAULT_DAILY_HOURS = 8
export const TARGET_PER_HOUR_STORAGE_KEY = 'resports:userPostings:targetPerHour'
export const DAILY_HOURS_STORAGE_KEY = 'resports:userPostings:dailyHours'
export const RED = '#FF7373'
export const GREEN = '#3DCC91'
export const BORDER_TOP = { borderTop: '1px solid black' }
export const TABS = {
  USER_PRODUCTIVITY: 'userProductivity',
  POSTER_OVERVIEW: 'posterOveriew',
  POSTER_TARGET: 'posterTargets',
  EVENT_LOGS: 'eventLogs',
  SALES_BY_CATEGORY: 'salesByCategory',
  POSTING_TOTALS: 'postingTotals',
  SGW_LISTINGS: 'sgwListings',
  GWF_LISTINGS: 'gwfListings',
  EBAY_LISTINGS: 'ebayListings',
  OFFER_UP_LISTINGS: 'offerUpListings',
  SHOPIFY_LISTINGS: 'shopifyListings',
  ETSY_LISTINGS: 'etsyListings',
  AMAZON_LISTINGS: 'amazonListings',
  ORDERS: 'orders',
  PAID_ORDERS: 'paidOrders',
  ORDER_ITEMS: 'orderItems',
  MANIFEST_ITEMS: 'manifestItems',
  SHIPMENTS: 'shipments',
  PRODUCTS: 'products',
  REFUNDS: 'refunds',
  BLUEBOX_ORDER_ITEMS_BY_LOCATION: 'bbOrderItemsByLocation',
  LOCAL_PRODUCTS: 'localProducts',
  EMBEDDED_LISTINGS: 'embeddedListings'
}
